import { instance } from '@/libs/api/instance.js'

/**
 * Get session by id
 *
 *  @param {string} id - A session id
 *  @return {Promise<AxiosResponse<any>>}
 */

export const getSession = async (id) => {
  return instance.get(`/v2/auth/${id}`)
}
